import useMailQueueTracking from 'helpers/hooks/useMailQueueTracking';

const MailQueueTrackingHandler = () => {
  useMailQueueTracking();
  return null;
};

export default MailQueueTrackingHandler;
